export default "__VITE_ASSET__CylZcyps__"